import { render, staticRenderFns } from "./PopupErrorDisplay.vue?vue&type=template&id=0497d4cb"
import script from "./PopupErrorDisplay.vue?vue&type=script&lang=js"
export * from "./PopupErrorDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports